import { Box } from "@mantine/core";
import { Navigate, Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { useProperty } from "@/hooks/useProperty";
import { useWebSocket } from "@/hooks/useWebSocket";
import { useAuthStore } from "@/stores/auth";

export function DashboardLayout() {
  const { companyId, properties, adminJumpLoading } = useProperty();
  const isSystemAdmin = useAuthStore((s) => s.isSystemAdmin);

  // Hooks must run unconditionally — keep this above any early return.
  useWebSocket(companyId);

  // If user has no properties, redirect to setup wizard. System admins are
  // exempt: they may be visiting a zero-property company (or own none).
  if (properties.length === 0 && !isSystemAdmin && !adminJumpLoading) {
    return <Navigate to="/setup" replace />;
  }

  return (
    <Box style={{ display: "flex", height: "100dvh", overflow: "hidden" }}>
      {/* Left sidebar */}
      <Sidebar />

      {/* Main area: header + content */}
      <Box style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
        <Header />

        {/* Content area - padding applied here, individual pages can override with negative margin */}
        <Box
          component="main"
          style={{ flex: 1, overflow: "auto" }}
          p="md"
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
